<template>
  <div>
    <Tooltip content="创建的所有资源都归入该项目" placement="bottom-end">
      <span>项目：</span>
    </Tooltip>
    <Dropdown trigger="click" @on-click="selectTenant" transfer>
      <a href="javascript:void(0)">
        {{ title }}
        <Icon :size="18" type="md-arrow-dropdown" />
      </a>
      <DropdownMenu slot="list" class="tenant-select">
        <DropdownItem v-for="item in $store.state.user.tenants" :name="item.id" :key="item.id" :selected="$store.state.user.defaultTenant === item.id">{{ item.name }}</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'Tenant',
  data () {
    return {
    }
  },
  computed: {
    title () {
      return this.$store.state.user.tenants.filter(item => item.id === this.$store.state.user.defaultTenant)[0].name
    }
  },
  methods: {
    ...mapActions([
      'saveDefaultTenant'
    ]),
    selectTenant (name) {
      this.$store.state.user.defaultTenant = name
      this.saveDefaultTenant(name)
    }
  }
}
</script>

<style>
  .tenant-select {
    padding: 0;
    overflow-y: auto;
    max-height: 300px;
    padding-bottom: 5px;
  }
  .tenant-select::-webkit-scrollbar {
    width: 5px;
  }
  .tenant-select::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .tenant-select::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
